import { render, staticRenderFns } from "./agv-photo-selector.vue?vue&type=template&id=3227cfd3&scoped=true&lang=pug&"
import script from "./agv-photo-selector.vue?vue&type=script&lang=js&"
export * from "./agv-photo-selector.vue?vue&type=script&lang=js&"
import style0 from "./agv-photo-selector.vue?vue&type=style&index=0&id=3227cfd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3227cfd3",
  null
  
)

export default component.exports